export default __webpack_public_path__ + "static/media/mobileappdesign.e43c0574.gif";